import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class DateMaskProcessing extends InputMaskProcessingBase {
  protected fixedPosGroupingChars = [null, null, '/', null, null, '/'];
  protected maxLength = 10;

  protected isCharAllowed(pos: number): boolean {
    // TODO: check edge cases like single digit month, double-digit year, position-specific allowed numbers
    return '0123456789'.indexOf(this.processed.value[pos]) > -1;
  }
}
